import { Agent, AgentInfo } from "../../schema/types/agent";
import moment from "moment-timezone";
import { dateString } from "../../components/dateStringFn";
import { formatStrings } from "../../utils/time";
import jsYaml from "js-yaml";
import { maxBy } from "lodash";

export const AGENT_CHECKING = "Checking";

function getMostRecentLastActive(infos: AgentInfo[]): string | undefined {
  const mostRecent = maxBy(infos, (info) => {
    if (!info.lastActive || info.lastActive === AGENT_CHECKING || info.lastActive.length === 0) {
      return 0;
    }
    return moment(info.lastActive).valueOf();
  });
  return mostRecent?.lastActive;
}

export const agentHelpers = {
  getEnvText(_agent: Agent, infos: AgentInfo[] | undefined) {
    if (infos && infos.length > 0) {
      return jsYaml.dump(infos, { indent: 2, noRefs: true });
    }
    return "Details not found";
  },
  getLastActiveText(_agent: Agent, infos: AgentInfo[] | undefined) {
    try {
      if (!infos || infos.length === 0) {
        throw new Error("no info found");
      }
      const lastActive = getMostRecentLastActive(infos);
      if (lastActive !== undefined && lastActive !== AGENT_CHECKING && lastActive.length > 0) {
        return dateString(lastActive, { format: formatStrings.humanizeWAgo });
      }
      throw new Error("no last active found");
    } catch (e) {
      return "This agent was never active";
    }
  },
  getLastActiveTextTable(_agent: Agent, infos: AgentInfo[] | undefined) {
    if (infos && infos.some((info) => info.lastActive === AGENT_CHECKING)) {
      return AGENT_CHECKING;
    }
    try {
      if (!infos || infos.length === 0) {
        throw new Error("no info found");
      }
      const lastActive = getMostRecentLastActive(infos);
      if (lastActive !== undefined && lastActive.length > 0) {
        return dateString(lastActive, { format: formatStrings.humanizeWAgo });
      }
      throw new Error("no last active found");
    } catch (e) {
      return "Never";
    }
  },
  getIsActive(_agent: Agent, infos: AgentInfo[] | undefined) {
    if (!infos || infos.length === 0) return false;
    try {
      const lastActive = getMostRecentLastActive(infos);
      if (!lastActive || lastActive === AGENT_CHECKING || lastActive.length === 0) return false;
      const lastActiveDate = moment(lastActive);
      const nowDate = moment();
      const diff = nowDate.diff(lastActiveDate, "seconds");
      return diff <= 60;
    } catch (e) {
      return false;
    }
  },
};

export interface AgentTableItem extends Agent {
  selfLink: string;
  isActive: boolean;
  lastActiveText: string;
}
